var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-between" } },
        [
          _c(
            "el-col",
            {
              staticStyle: { position: "relative" },
              attrs: { xl: 24, lg: 24 },
            },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.params.demension,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "demension", $$v)
                    },
                    expression: "params.demension",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("month-profits::site-pofits::tab_title"),
                      name: "1",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("month-profits::staff-pofits::tab_title"),
                      name: "2",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "date-wrap" },
                [
                  _c("label", { staticStyle: { width: "50px" } }, [
                    _vm._v(_vm._s(_vm.$t("month-profits::date"))),
                  ]),
                  _c("el-date-picker", {
                    staticClass: "date-input",
                    attrs: {
                      appendToBody: false,
                      clearable: false,
                      align: "right",
                      "unlink-panels": "",
                      "picker-options": _vm.pickerOptions,
                      type: "month",
                      placeholder: "选择月",
                    },
                    on: { change: _vm.handlerDateChange },
                    model: {
                      value: _vm.selectMonth,
                      callback: function ($$v) {
                        _vm.selectMonth = $$v
                      },
                      expression: "selectMonth",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedShop.label,
              expression: "selectedShop.label",
            },
          ],
          staticStyle: { "margin-top": "10px", "margin-left": "16px" },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.params.demension === "1"
                  ? _vm.$t("month-profits::site-pofits::name")
                  : _vm.$t("month-profits::staff-pofits::name")
              ) +
              "： "
          ),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.goBack } },
            [_vm._v(_vm._s(_vm.selectedShop.label))]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "reportTable",
                  staticClass: "databoard-table",
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.profitTableConfig },
                },
                [
                  _vm.params.demension === "1"
                    ? _c(
                        "p",
                        {
                          staticStyle: { color: "#666" },
                          attrs: { slot: "other" },
                          slot: "other",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("month-profits::site-pofits::tip_sales")
                              ) +
                              "：" +
                              _vm._s(
                                _vm.$dataCheck(_vm.count.currency, "") +
                                  (_vm.count.amount || 0)
                              ) +
                              " - " +
                              _vm._s(
                                _vm.$t("month-profits::site-pofits::tip_pay")
                              ) +
                              " ：" +
                              _vm._s(
                                _vm.$dataCheck(_vm.count.currency, "") +
                                  (_vm.count.cost || 0)
                              ) +
                              " = " +
                              _vm._s(
                                _vm.$t("month-profits::site-pofits::tip_profit")
                              ) +
                              "：" +
                              _vm._s(
                                _vm.$dataCheck(_vm.count.currency, "") +
                                  (_vm.count.turnover || 0)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _c(
                        "p",
                        {
                          staticStyle: { color: "#666" },
                          attrs: { slot: "other" },
                          slot: "other",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("month-profits::staff-pofits::tip_sales")
                              ) +
                              "：" +
                              _vm._s(
                                _vm.$dataCheck(_vm.count.currency, "") +
                                  (_vm.count.amount || 0)
                              ) +
                              " - " +
                              _vm._s(
                                _vm.$t("month-profits::staff-pofits::tip_pay")
                              ) +
                              " ：" +
                              _vm._s(
                                _vm.$dataCheck(_vm.count.currency, "") +
                                  (_vm.count.cost || 0)
                              ) +
                              " = " +
                              _vm._s(
                                _vm.$t(
                                  "month-profits::staff-pofits::tip_profit"
                                )
                              ) +
                              "：" +
                              _vm._s(
                                _vm.$dataCheck(_vm.count.currency, "") +
                                  (_vm.count.turnover || 0)
                              ) +
                              " "
                          ),
                        ]
                      ),
                  !_vm.selectedShop.label
                    ? _c("el-table-column", {
                        key: "shopName",
                        attrs: {
                          prop:
                            _vm.params.demension === "1"
                              ? "shopName"
                              : "campaignName",
                          label:
                            _vm.params.demension === "1"
                              ? _vm.$t(
                                  "month-profits::site-pofits::table_shopName"
                                )
                              : _vm.$t(
                                  "month-profits::staff-pofits::table_name"
                                ),
                          "min-width": "150",
                          "show-overflow-tooltip": true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.shopName !== "总计" &&
                                  scope.row.campaignName !== "总计"
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toDetail(scope.row)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.params.demension === "1"
                                                  ? scope.row.shopName
                                                  : scope.row.campaignName
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.params.demension === "1"
                                              ? scope.row.shopName
                                              : scope.row.campaignName
                                          )
                                        ),
                                      ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          93832118
                        ),
                      })
                    : _c("el-table-column", {
                        key: "date",
                        attrs: {
                          prop: "date",
                          label: _vm.$t("month-profits::date"),
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(" " + _vm._s(scope.row.date) + " "),
                              ]
                            },
                          },
                        ]),
                      }),
                  _vm.params.demension === "1" || _vm.selectedShop.label
                    ? _c("el-table-column", {
                        key: "sale",
                        attrs: {
                          prop: "sale",
                          label: _vm.$t(
                            "month-profits::site-pofits::table_salesNum"
                          ),
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$dataCheck(scope.row.sale)) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          265581269
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    key: "amount",
                    attrs: {
                      prop: "amount",
                      label:
                        _vm.$t("month-profits::site-pofits::table_salesMoney") +
                        "(USD)",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm.$dataCheck(scope.row.amount))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    key: "adCost",
                    attrs: {
                      prop: "adCost",
                      label:
                        _vm.$t("month-profits::site-pofits::table_adcost") +
                        "(USD)",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm.$dataCheck(scope.row.adCost))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.params.demension === "2" && _vm.selectedShop.label === ""
                    ? _c("el-table-column", {
                        key: "roi",
                        attrs: {
                          prop: "roi",
                          label: _vm.$t(
                            "month-profits::staff-pofits::table_roi"
                          ),
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(_vm._s(_vm.$dataCheck(scope.row.roi))),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1741614970
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    key: "proCost",
                    attrs: {
                      prop: "proCost",
                      label:
                        _vm.$t("month-profits::site-pofits::table_proCost") +
                        "(USD)",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(_vm._s(_vm.$dataCheck(scope.row.proCost))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    key: "logisticsCost",
                    attrs: {
                      prop: "logisticsCost",
                      label:
                        _vm.$t(
                          "month-profits::site-pofits::table_logisticsCost"
                        ) + "(USD)",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.logisticsCost))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    key: "refundAmount",
                    attrs: {
                      prop: "refundAmount",
                      label:
                        _vm.$t(
                          "month-profits::site-pofits::table_refundAmount"
                        ) + "(USD)",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.refundAmount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    key: "grossProfit",
                    attrs: {
                      prop: "grossProfit",
                      label:
                        (_vm.params.demension === "1"
                          ? _vm.$t(
                              "month-profits::site-pofits::table_grossProfit"
                            )
                          : _vm.$t(
                              "month-profits::staff-pofits::table_grossProfit"
                            )) + "(USD)",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.grossProfit))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    key: "grossMargin",
                    attrs: {
                      prop: "grossMargin",
                      "min-width": "120",
                      label:
                        _vm.params.demension === "1"
                          ? _vm.$t(
                              "month-profits::site-pofits::table_grossMargin"
                            )
                          : _vm.$t(
                              "month-profits::staff-pofits::table_grossMargin"
                            ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(scope.row.grossMargin)) +
                                "%"
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }